module.exports = __webpack_public_path__ + "images/play@2x.png?71e40f90";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/play@2x.png
// module id = 237
// module chunks = 7